/**
 * ? @description : Page Not Found Component
 */

// Dependencies
import React, { Fragment } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Asset
import ErrorImage from "../../../assets/404ErrorPage.png";

// CSS Component
import "./NotFoundPage.css";

function NotFoundPage() {
  // * Router Variable
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box className="NotFoundPage">
        {/* Image */}
        <Box>
          <img
            src={ErrorImage}
            alt="Error 404 - Not Found"
            className="NotFoundImage"
          />
        </Box>

        {/* Button */}
        <Box>
          <Button
            type="button"
            variant="contained"
            color="primary"
            sx={{ bgcolor: "#1D3FAA" }}
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Fragment>
  );
}

export default NotFoundPage;
